module.exports = __webpack_public_path__ + "static/media/TOP SLIDE ASSEMBLY ( 466-00334 )FOR SDS 900-1200 MACHINES..33f49e45.jpg";